import { render, staticRenderFns } from "./Faq1.vue?vue&type=template&id=7981bf92&scoped=true&"
import script from "./Faq1.vue?vue&type=script&lang=js&"
export * from "./Faq1.vue?vue&type=script&lang=js&"
import style0 from "./Faq1.vue?vue&type=style&index=0&id=7981bf92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7981bf92",
  null
  
)

export default component.exports